import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {map, Observable, switchMap} from "rxjs";
import {AuthService} from "../services/auth.service";
import RelationContact from "../model/relation-contact.model";
import {Scope} from "../enums/scope";

export const allScopeGuard: CanActivateFn = (): Observable<boolean> => {
  const authService: AuthService = inject(AuthService);

  /**
   * @description check if the currently active scope has rights to see the page
   */

  return authService.isLoggedIn().pipe(
    switchMap((loggedIn: boolean) => {
      if (!loggedIn) {
        return [false];
      }
      return authService.getUser().pipe(
        map((user: RelationContact | null) => {
          if (!user) {
            return false;
          }
          return user.scope.type === Scope.ALL;
        })
      );
    })
  ).pipe(
    map((canView: boolean) => {
      if (canView) {
        return true;
      }
      authService.logout().subscribe(); // subscribe to wait for logout to finish
      return false;
    })
  );
}
